import React from "react";

export interface PlayerPhotoSelectProps {
  name: string;
  onTakePhoto: () => void;
  onChooseAvatar: () => void;
  onBack: () => void;
}

export const PlayerPhotoSelect: React.FC<PlayerPhotoSelectProps> = ({
  name,
  onTakePhoto,
  onChooseAvatar,
  onBack,
}) => {
  return (
    <div className="pageContainer">
      <div className="logoContainer">
        <img src={"./img/es-logo.svg"} width="110px" alt="Electric Shuffle" />
      </div>
      <div className="contentCard">
        <div className="formContainer">
          <div className="formHeader">
            <div className="step">Step 2/3</div>
            <div className="title">Your photo</div>
          </div>
          <button className="takePhotoBtn" onClick={onTakePhoto}>
            TAKE A PHOTO
          </button>
          <button className="no-background chooseAvatarBtn" onClick={onChooseAvatar}>
            Choose Avatar
          </button>
          <div className="starsContainer">
            <img src={"./img/stars.svg"} alt="Stars" className="stars" />
          </div>
        </div>
      </div>
      <footer className="btn-container">
        <button className="small secondary" onClick={onBack}>
          BACK
        </button>
        <button className="small" disabled onClick={onTakePhoto}>
          NEXT
        </button>
      </footer>
    </div>
  );
};
